import { deletedata } from '@/util/global';
import React from 'react';

const PaymentTable = ({ paymentdata}) => {
  const rows = [];

  for (let i = 0; i < paymentdata.length; i++) {
    const a = paymentdata[i];
    const orderstatus = a.orderdata[a.orderdata.length-1];
    rows.push(
      <tr key={a._id || i}>
        <td>{a.updatetimestamp}</td>
        <td>{a.inr}</td>
        <td>{orderstatus.order_status}</td>
        <td>{a.messagecredit}</td>
      </tr>
    );
  }

  return (
    <table className="grid" >
      <thead>
        <tr><th>timestamp</th><th>inr</th><th>order status</th><th>message credit</th></tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
};

export default PaymentTable;